import {createAsyncThunk} from '@reduxjs/toolkit'
import {PackingSlipShortcodesParams} from 'src/interfaces/PackingSlipTemplate.interface'
import AxiosClient from '../AxiosClient'

/** Relative to REACT_APP_API_URL (e.g. https://host/market_connect + /api/...). */
const PACKING_SLIP_SHORTCODES_PATH = '/api/packing-slip-shortcodes'
const PACKING_SLIP_DEFAULT_TEMPLATES_PATH = '/api/packing-slip-default-templates'

export const fetchUserAccountDetailsAsync = createAsyncThunk(
  'user/fetchUserAccountDetailsAsync',
  async function ( payload: { useAdminToken?: boolean } | undefined, toolkit) {
    return await AxiosClient('GET', '/api/authenticated-user', [], toolkit, [], undefined, undefined, payload?.useAdminToken)
  }
)

export const updatePlatformConnectionPriorityAsync = createAsyncThunk(
  'user/updatePlatformConnectionPriorityAsync',
  async function (payload: {platform_connection_priority: string}, toolkit) {
    return await AxiosClient('PUT', '/api/authenticated-user', payload, toolkit, [])
  }
)

export const fetchTemuCountryAsync = createAsyncThunk(
  'user/fetchTemuCountry',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/api/temu-country', [], toolkit, [])
  }
)

export const fetchSkipSetupAsync = createAsyncThunk(
  'user/fetchSkipSetupAsync',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/user/skip-setup', [], toolkit, [])
  }
)

export const fetchCountriesAsync = createAsyncThunk(
  'user/fetchCountriesAsync',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/api/countries/', [], toolkit, [])
  }
)

export const fetchStatesAsync = createAsyncThunk(
  'user/fetchStatesAsync',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/api/states/', [], toolkit, [])
  }
)

export const fetchStatesByCountryAsync = createAsyncThunk(
  'user/fetchStatesByCountryAsync',
  async function (payload: {countryId: number | string}, toolkit) {
    return await AxiosClient('GET', `/api/states?country_id=${payload.countryId}`, [], toolkit, [])
  }
)



export const generateMfaQrCodeAsync = createAsyncThunk(
  'user/generate-qr-code',
  async function (payload, toolkit) {
    return await AxiosClient('POST', '/user/generate-qr-code', [], toolkit, [])
  }
)

export const verifyMfaCodeAsync = createAsyncThunk(
  'user/validate-mfa-code',
  async function (payload: {code: number,mfa_enabled:boolean}, toolkit) {
    return await AxiosClient('GET', '/user/validate-mfa-code?code='+payload.code+'&mfa_enabled='+payload.mfa_enabled,[] , toolkit, [])
  }
)

export const acceptTermsAndConditionsAsync = createAsyncThunk(
  'user/acceptTermsAndConditionsAsync',
  async function (_payload: void, toolkit) {
    return await AxiosClient('POST', '/user/accept_terms_and_conditions', [], toolkit, [])
  }
)

export const saveUserInvoiceProfileAsync = createAsyncThunk(
  'user/saveUserInvoiceProfileAsync',
  async function (payload: {userId: number; data: object}, toolkit) {
    return await AxiosClient('POST', `/api/user-profile/${payload.userId}/`, payload.data, toolkit, [])
  }
)

export const getUserInvoiceProfileAsync = createAsyncThunk(
  'user/getUserInvoiceProfileAsync',
  async function (payload: {userId: number}, toolkit) {
    return await AxiosClient('GET', `/api/user-profile/${payload.userId}/`, [], toolkit, [])
  }
)

export const fetchCurrenciesAsync = createAsyncThunk(
  'user/fetchCurrenciesAsync',
  async function (payload: void, toolkit) {
    return await AxiosClient('GET', '/api/currency-details', [], toolkit, [])
  }
)

export const getUserEmailTemplatesAsync = createAsyncThunk(
  'user/getUserEmailTemplatesAsync',
  async function (payload: {userId: number; type: 'INVOICE' | 'PACKING_SLIP'}, toolkit) {
    return await AxiosClient('GET', `/api/user-email-templates/${payload.userId}/?type=${payload.type}`, [], toolkit, [])
  }
)


export const deleteUserEmailTemplateAsync = createAsyncThunk(
  'user/deleteUserEmailTemplateAsync',
  async (templateId: number, toolkit) => {
    return await AxiosClient(
      'DELETE',
      `/api/user-email-templates/${templateId}/`,
      [],
      toolkit,
      []
    )
  }
)

export const getPackingSlipShortcodesAsync = createAsyncThunk(
  'user/getPackingSlipShortcodesAsync',
  async function (params: PackingSlipShortcodesParams | undefined, toolkit) {
    const queryParams: Record<string, string> = {}

    if (params?.shortcode_group?.trim()) {
      queryParams.shortcode_group = params.shortcode_group.trim()
    }

    return await AxiosClient(
      'GET',
      PACKING_SLIP_SHORTCODES_PATH,
      [],
      toolkit,
      queryParams
    )
  }
)

export const getPackingSlipDefaultTemplatesAsync = createAsyncThunk(
  'user/getPackingSlipDefaultTemplatesAsync',
  async function (_payload: void, toolkit) {
    return await AxiosClient(
      'GET',
      PACKING_SLIP_DEFAULT_TEMPLATES_PATH,
      [],
      toolkit,
      []
    )
  }
)

